export const dishwasherId = '5088539490001';
export const electricRangeId = '5088539402001';
export const gasRangeId = '5088529744001';
export const microwaveId = '5088529750001';
export const fridgeId = '5088539496001';
export const washingMachineId = '5088542623001';
export const dryerId = '5088514006001';

export const dishwasher = [
  'New dishwasher connection kit',
  'Water supply line (shutoff) within 6 ft. of hook up',
  'Electrical outlet within 6 ft. of hook up',
  'The rough cabinet opening must be at least: 24" W X 24" D X 34–1/2" H',
  'Measure your rough cabinet opening',
  'Verify your existing electrical and water connections',
  'Empty and unplug your old dishwasher'
];

export const electricRange = [
  'A new electrical cord',
  'A 240V electric outlet within 4 ft. of hookup',
  'Verify that your outlet type matches the approved types shown above',
  'Empty & unplug your old appliance'
];

export const gasRange = [
  'New gas flex connection kit',
  'Natural gas line (no liquid propane hookups)',
  '110V-grounded, 3-prong electrical outlet',
  'Gas shutoff directly behind the appliance',
  'Verify your existing electrical & water connections',
  'Empty & unplug your old appliance'
];

export const microwave = [
  'Hardwiring will not be done. A dedicated 110V electric outlet must be directly above the unit'
];

export const fridge = [
  'Water connection kit required',
  '110V-grounded, 3-prong electrical outlet',
  'Water valve (shutoff) within 6 ft. of hook up',
  'Measure the delivery path and new appliance area to make sure that your refrigerator will fit perfectly',
  'Verify your existing electrical and water connections',
  'Empty & unplug your old refrigerator'
];

export const washingMachine = [
  'Water valves (hot and cold) must be corrosive free and within 6 ft. of hookup',
  'Verify your existing electrical and water connections',
  'Empty & unplug your old appliance'
];

export const gasDryer = [
  'New gas flex connection kit',
  'Natural gas line (no liquid propane hookups)',
  '110V-grounded, 3-prong electrical outlet',
  'Gas shutoff directly behind the appliance',
  'Verify your existing electrical & water connections',
  'Empty & unplug your old appliance'
];

export const electricDryer = [
  'A new electrical cord',
  'A 240V electric outlet within 4 ft. of hookup',
  'Verify that your outlet type matches the approved types shown above',
  'Empty & unplug your old appliance'
];

export const textData = new Map([
  [
    dishwasherId,
    dishwasher
  ],
  [
    electricRangeId,
    electricRange
  ],
  [
    gasRangeId,
    gasRange
  ],
  [
    microwaveId,
    microwave
  ],
  [
    fridgeId,
    fridge
  ],
  [
    washingMachineId,
    washingMachine
  ],
  [
    dryerId, (dryerType) => {
      if (dryerType === 'Gas Dryer') {
        return gasDryer;
      }
      if (dryerType === 'Electric Dryer') {
        return electricDryer;
      }
      return null;
    }
  ]
]);

export const getApplianceText = (videoId, dryerType) => {
  if (!videoId) {
    return null;
  }

  let applianceText = textData.get(videoId);
  if (!applianceText) {
    return null;
  }

  if (applianceText instanceof Function) {
    applianceText = applianceText(dryerType);
  }

  return applianceText;
};

export const getVideoId = (videos) => {
  let videoToUse = videos.find((video) => video.type === 'BRIGHTCOVE SUPPLEMENT 1');

  if (!videoToUse) {
    videoToUse = videos.find((video) => video.type === 'BRIGHTCOVE SUPPLEMENT 2');
  }
  return videoToUse?.videoId || null;
};